<template>
  <div class="card">
    <div class="van-row--flex ">
      <h1>{{ $t('ProductInfo.historical_usage_per_day') }}</h1>

      <van-tag v-if="isMineDevice" @click="onTagChange(1)" round type="primary"
               :plain="selectTag === 2"
               style="margin-left:10px">{{ $t('ProductInfo.day_7') }}
      </van-tag>
      <van-tag v-if="isMineDevice" @click="onTagChange(2)" round type="primary"
               :plain="selectTag === 1"
               style="margin-left:10px">{{ $t('ProductInfo.week_7') }}
      </van-tag>

    </div>

    <div class="chart-wrapper">
      <ApexChart type="line" :options="options" :series="processedSeries" class="chart"/>
      <div class="chart-lock" @click="showUsage" v-show="!isMineDevice">
        <div
            style="display: flex;align-items: center;justify-content: center;flex-direction: column;width:100%;height:100%">

          <van-icon name="lock"/>
          <!--          <p v-if="deviceBindUserId === 0" @click="bindDevice">点击绑定设备，查看数据</p>-->
          <p>{{$t("ProductInfo.NoYourDevice")}}</p>
        </div>
      </div>
    </div>
    <div style="font-size:10px; margin-top:10px;margin-bottom:10px">
      {{ $t('ProductInfo.historical_usage_graph_description') }}
    </div>
  </div>
</template>

<script>
import ApexCharts from "vue-apexcharts";
import {mapGetters, mapState} from "vuex";
import {colors} from "@/config";
import user from "@/api/user";
// import {user} from "src/api";

export default {
  name: "JzzDashCartridgeUsage",
  components: {
    ApexChart: ApexCharts,
  },
  props: {
    deviceBindUserId: {
      type: Number,
      default: 0
    }
  },


  data() {
    return {
      startDate: (() => {
        const now = new Date()
        now.setDate(now.getDate() - 14);
        return now
      })(),
      selectTag: 1,
      isLocked: true,
      highestValue: 1.0,
      seriesData: [], // source can be props
      options: {
        theme: {
          monochrome: {
            enabled: true,
            color: colors.main,
          },
        },

        tooltip: {
          fillSeriesColor: true,
          theme: 'dark'
        },
        chart: {
          toolbar: {
            show: false, // Enable toolbar for zoom functionality

            tools: {
              zoom: false,
              pan: false,
              selection: false,
            }
          },
          id: "vuechart",
          zoom: {
            enabled: false,
            type: "x", // Enable zooming on the x-axis
            autoScaleYaxis: true, // Auto scale y-axis when zooming
          },
          defaultLocale: "zh",
          locales: [
            {
              name: "en",
              options: {
                months: [
                  "January",
                  "February",
                  "March",
                  "April",
                  "May",
                  "June",
                  "July",
                  "August",
                  "September",
                  "October",
                  "November",
                  "December",
                ],
                shortMonths: [
                  "Jan",
                  "Feb",
                  "Mar",
                  "Apr",
                  "May",
                  "Jun",
                  "Jul",
                  "Aug",
                  "Sep",
                  "Oct",
                  "Nov",
                  "Dec",
                ],
                days: [
                  "Sunday",
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                ],
                shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                toolbar: {
                  download: this.$t("ProductInfo.download_svg"),
                  selection: this.$t("ProductInfo.selection"),
                  selectionZoom: this.$t("ProductInfo.selectionZoom"),
                  zoomIn: this.$t("ProductInfo.zoomIn"),
                  zoomOut: this.$t("ProductInfo.zoomOut"),
                  pan: this.$t("ProductInfo.pan"),
                  reset: this.$t("ProductInfo.reset"),
                },
              },
            },
            {
              name: "zh",
              options: {
                months: [
                  "一月",
                  "二月",
                  "三月",
                  "四月",
                  "五月",
                  "六月",
                  "七月",
                  "八月",
                  "九月",
                  "十月",
                  "十一月",
                  "十二月"
                ],
                shortMonths: [
                  "01-",
                  "02-",
                  "03-",
                  "04-",
                  "05-",
                  "06-",
                  "07-",
                  "08-",
                  "09-",
                  "10-",
                  "11-",
                  "12-"
                ],
                days: [
                  "星期日",
                  "星期一",
                  "星期二",
                  "星期三",
                  "星期四",
                  "星期五",
                  "星期六"
                ],
                shortDays: [
                  "周日",
                  "周一",
                  "周二",
                  "周三",
                  "周四",
                  "周五",
                  "周六"
                ],
                toolbar: {
                  download: this.$t("ProductInfo.download_svg"),
                  selection: this.$t("ProductInfo.selection"),
                  selectionZoom: this.$t("ProductInfo.selectionZoom"),
                  zoomIn: this.$t("ProductInfo.zoomIn"),
                  zoomOut: this.$t("ProductInfo.zoomOut"),
                  pan: this.$t("ProductInfo.pan"),
                  reset: this.$t("ProductInfo.reset"),
                },
              },
            },
          ],
          // events: {
          //   mounted: function (chartContext, config) {
          //     // Move to the last data point after the chart is mounted
          //     const series = chartContext.w.globals.series[0];
          //     const lastIndex = series.length - 1;
          //     const lastDate = chartContext.w.globals.seriesX[0][lastIndex];
          //     chartContext.zoomX(lastDate - 7 * 24 * 60 * 60 * 1000, lastDate); // View the last 7 days
          //   }
          // }
        },
        xaxis: {
          type: 'category',
          categories: [],
          labels: {
            style: {
              colors: colors.main,
            },
          },
          // min: new Date("2024-06-01").getTime(), // Default to start of the data range
          // max: new Date("2024-06-07").getTime(),
        },
        yaxis: [{
          min: 0,
          max: 100,
          tickAmount: 5,
          labels: {
            style: {
              colors: colors.main,
            },
          },
        }],
        dataLabels: {
          enabled: false,
        },
        grid: {
          show: false,
        },
      },
    };
  },

  computed: {
    ...mapGetters("user", ["loggedIn"]),
    ...mapState("user", ["userInfo"]),
    ...mapState("cartridge", ["deviceInfo"]),
    isMineDevice() {
      return this.deviceBindUserId === this.userInfo.id
    },
    processedSeries() {
      return [
        {
          name: "Seconds",
          data: [].concat(this.seriesData),
        },
      ];
    },
  },
  methods: {
    async onTagChange(tag) {
      this.selectTag = tag
      await this.fetchData()

      this.updateYAxis(); // Update y-axis scale when component is mounted
    },
    showUsage() {
      // if (!this.loggedIn) {
      //   this.$router.push('/auth/login')
      //   return
      // }
      // this.isLocked = false;
      // this.options.xaxis.labels.style.colors = colors.dark;
      // this.options.yaxis.labels.style.colors = colors.dark;

      // this.options = Object.assign({}, this.options);

    },
    calculateYAxisMax(highestValue) {
      let operateNum = highestValue
      let base = 0

      while (operateNum / 10 > 1) {
        base += 1
        operateNum /= 10
      }


      const baseNum = Math.pow(10, base)
      let ret = 0
      if (highestValue % baseNum > 0) {
        ret += parseInt((highestValue / baseNum) + 1) * baseNum
      } else {
        ret = highestValue
      }
      return ret
    },

    updateYAxis() {
      const maxDataValue = Math.max(...this.seriesData);
      let newMax = this.calculateYAxisMax(maxDataValue);
      newMax = newMax === 0 ? 100 : newMax;
      this.options.yaxis[0].max = newMax;
      this.highestValue = newMax;

      this.options = Object.assign({}, this.options); // Force update
    },

    getStartDate(offset = 0) {
      const startDate = new Date(this.startDate.getTime()); // Starting date
      startDate.setDate(startDate.getDate() + offset);
      return startDate;
    },

    getLastFourteenDays() {
      function formatDate(date) {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      }

      const dates = [];
      const today = new Date();

      for (let i = 0; i < 7; i++) {
        const date = new Date();
        date.setDate(today.getDate() - i);
        dates.push(formatDate(date));
      }

      return dates;
    },
    async fetchData() {
      const recentTimeUsagesResp = await user.recentTimeUsages({
        type: this.selectTag,
        deviceTag: this.deviceInfo.deviceTag
      })
      const data = recentTimeUsagesResp.data;
      const time = data.map(item => item.time)
      const seconds = data.map(item => {
        return this.isMineDevice ? item.seconds || 0 : 0
      })
      const min = new Date(`2024-${time[0]}`)
      const max = new Date(`2024-${time[time.length - 1]}`)
      // this.startDate = min;
      // this.options.xaxis.min = min.getTime()
      // this.options.xaxis.max = max.getTime()
      this.options.xaxis.categories = time
      // this.series[0].data = seconds
      // this.options = Object.assign({}, this.options)
      this.seriesData = [...seconds]
    }
  },
  async mounted() {
    //
    if (this.loggedIn) {
      await this.fetchData()

      this.updateYAxis(); // Update y-axis scale when component is mounted
    } else {
      const dates = this.getLastFourteenDays()
      this.options.xaxis.min = new Date(dates[dates.length - 1]).getTime()
      this.options.xaxis.max = new Date(dates[0]).getTime()
    }
  }
};
</script>

<style scoped lang="less">
.card {
  & > * + * {
    margin-top: 0.75rem;
  }

  h1 {
    font-size: clamp(10px, 1vw, 12px);
    font-weight: bold;
  }
}

.chart {
  width: 100%;

  &-opacity-30 {
    opacity: 30%;
  }

  &-opacity-100 {
    opacity: 100%;
  }

  &-wrapper {
    height: auto;
    position: relative;
  }

  &-lock {
    position: absolute;

    padding: 1px 3px;
    display: flex;
    align-items: center;
    column-gap: 4px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.1);
    cursor: pointer;

    p {
      text-align: center;
      font-size: clamp(12px, 1vw, 14px);
    }
  }
}

.card {
  padding: 12px;
  background: #222222;
  margin: 10px 0;
}

::v-deep .apexcharts-tooltip {
  background: #f3f3f3;
  color: black;
}

::v-deep #apexchartsvuechart > div.apexcharts-toolbar > div.apexcharts-menu.apexcharts-menu-open {
  color: #282828;
}
</style>
